function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.346 41.356C30.19 43.25 24.638 64.854 31.345 87.66c6.706 22.806 36.913 13.698 50.906 17.033 13.992 3.335 40.953-1.144 40.953-21.093 0-19.948-17.871-7.899-23.117-26.019-5.247-18.12-23.584-18.12-46.74-16.225z",
  fill: "#FFF5DC"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 111.089,
  cy: 111.563,
  rx: 2.656,
  ry: 2.647,
  fill: "#FF5A17"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 121.712,
  cy: 99.464,
  rx: 5.311,
  ry: 5.294,
  fill: "#FDB913"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.68 51.92a.958.958 0 010-1.356l3.103-3.093a.958.958 0 011.353 0l3.102 3.093a.958.958 0 010 1.357l-3.102 3.092a.958.958 0 01-1.353 0l-3.102-3.092z",
  fill: "#FDB913"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.248 50.569a.794.794 0 011.463-.018l1.61 3.69 3.418 1.881a.794.794 0 01.001 1.391l-3.419 1.889-1.463 3.637a.794.794 0 01-1.452.049l-1.654-3.427-3.591-1.992a.794.794 0 01-.006-1.385l3.597-2.042 1.496-3.673zM27.369 89.575a.794.794 0 011.463-.019l1.03 2.362 2.27 1.25a.794.794 0 010 1.39l-2.27 1.255-.94 2.335a.794.794 0 01-1.451.05l-1.057-2.19-2.406-1.335a.794.794 0 01-.007-1.385l2.413-1.37.955-2.344z",
  fill: "#F58220"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.806,
  cy: 42.592,
  rx: 14.423,
  ry: 14.393,
  fill: "#F6694C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M96.043 55.3l-3.387 4.884",
  stroke: "#F6694C",
  strokeWidth: 1.95,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 100.637,
  cy: 38.764,
  rx: 2.799,
  ry: 2.793,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M104.408 48.988H96.93a.929.929 0 01-.93-.928v-1.812c0-1.65 1.167-3.07 2.788-3.39l.342-.075a7.76 7.76 0 013.056 0l.342.074a3.456 3.456 0 012.788 3.39v1.813a.928.928 0 01-.908.928zM107.304 42.676l-.31-.064a6.626 6.626 0 00-2.671 0 4.347 4.347 0 011.945 3.625v1.813h2.703a.813.813 0 00.822-.821v-1.578a3.03 3.03 0 00-2.489-2.975zM105.765 36.898a2.308 2.308 0 00-1.613.661c.362.997.26 2.103-.278 3.018a2.332 2.332 0 002.832.773 2.324 2.324 0 00-.941-4.452z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 38.702,
  cy: 39.393,
  rx: 14.423,
  ry: 14.393,
  fill: "#F6694C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M46.715 51.654l4.273 9.596",
  stroke: "#F6694C",
  strokeWidth: 1.95,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.534,
  cy: 35.789,
  rx: 2.799,
  ry: 2.793,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M40.305 46.014h-7.479a.929.929 0 01-.93-.928v-1.813a3.456 3.456 0 012.768-3.347l.341-.075a7.76 7.76 0 013.056 0l.342.075a3.456 3.456 0 012.788 3.39v1.813a.928.928 0 01-.886.885zM43.2 39.702l-.31-.064a6.626 6.626 0 00-2.671 0 4.369 4.369 0 011.944 3.625v1.812h2.703a.813.813 0 00.823-.82v-1.579a3.03 3.03 0 00-2.49-2.974zM41.662 33.924a2.31 2.31 0 00-1.614.66c.362.998.26 2.104-.278 3.018a2.332 2.332 0 002.832.773 2.323 2.323 0 00-.94-4.451z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M92.656 65.514l-5.262 4.264 6.615 6.467-1.353-10.731z",
  fill: "url(#ralali-connect-illustration_svg__paint0_linear_164_13988)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M49.92 65.514l5.342 4.264-6.41 6.032 1.068-10.296z",
  fill: "url(#ralali-connect-illustration_svg__paint1_linear_164_13988)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.935 75.201l49.617.61c.456.009.84.331.934.767l.017.111 3.329 33.595a4.166 4.166 0 01-1.015 3.308 4.181 4.181 0 01-2.934 1.403l-.225.004h-4.956V115H75.073v-.001H46.905a4.184 4.184 0 01-3.167-1.407 4.147 4.147 0 01-1.045-3.017l.024-.228 2.222-34.234a.976.976 0 01.885-.908l.11-.004z",
  fill: "url(#ralali-connect-illustration_svg__paint2_linear_164_13988)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M95.552 75.81l-49.728-.61 9.438-5.422-5.342-4.264h42.736l-5.262 4.264 8.158 6.032z",
  fill: "url(#ralali-connect-illustration_svg__paint3_linear_164_13988)"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 59.536,
  cy: 85.771,
  rx: 2.137,
  ry: 2.132,
  fill: "#EEE"
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 80.903,
  cy: 85.771,
  rx: 2.137,
  ry: 2.132,
  fill: "#EEE"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M80.903 84.797c.54 0 .977.436.977.975 0 16.226-23.321 16.226-23.321 0a.976.976 0 011.953 0c0 13.626 19.415 13.626 19.415 0 0-.539.437-.975.976-.975z",
  fill: "url(#ralali-connect-illustration_svg__paint4_linear_164_13988)"
});

var _ref21 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 69.269,
  cy: 47.886,
  rx: 3.205,
  ry: 3.198,
  fill: "url(#ralali-connect-illustration_svg__paint5_linear_164_13988)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M73.542 59.614h-8.547c-.59 0-1.068-.477-1.068-1.066v-2.133a3.979 3.979 0 013.205-3.891l.395-.075a8.812 8.812 0 013.505 0l.395.075a3.979 3.979 0 013.205 3.892v2.132a1.065 1.065 0 01-1.09 1.066z",
  fill: "url(#ralali-connect-illustration_svg__paint6_linear_164_13988)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M76.908 52.375l-.342-.075a7.868 7.868 0 00-3.077 0 5.03 5.03 0 012.233 4.158v2.133h3.045a.93.93 0 00.94-.939v-1.865a3.478 3.478 0 00-2.799-3.412z",
  fill: "url(#ralali-connect-illustration_svg__paint7_linear_164_13988)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M75.145 45.754a2.674 2.674 0 00-1.848.746 4.184 4.184 0 01-.32 3.518 2.674 2.674 0 003.247.825 2.664 2.664 0 00-1.11-5.09h.031z",
  fill: "url(#ralali-connect-illustration_svg__paint8_linear_164_13988)"
});

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint0_linear_164_13988",
  x1: 86.981,
  y1: 72.263,
  x2: 93.794,
  y2: 76.584,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint1_linear_164_13988",
  x1: 55.663,
  y1: 71.99,
  x2: 49.098,
  y2: 76.195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint2_linear_164_13988",
  x1: 39.107,
  y1: 100.233,
  x2: 65.036,
  y2: 138.562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint3_linear_164_13988",
  x1: 47.267,
  y1: 72.189,
  x2: 49.75,
  y2: 84.817,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint4_linear_164_13988",
  x1: 59.235,
  y1: 93.319,
  x2: 66.203,
  y2: 106.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint5_linear_164_13988",
  x1: 65.662,
  y1: 48.711,
  x2: 70.15,
  y2: 53.338,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint6_linear_164_13988",
  x1: 63.257,
  y1: 56.891,
  x2: 68.013,
  y2: 64.026,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint7_linear_164_13988",
  x1: 73.1,
  y1: 56.2,
  x2: 77.622,
  y2: 60.691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ralali-connect-illustration_svg__paint8_linear_164_13988",
  x1: 72.676,
  y1: 49.107,
  x2: 76.407,
  y2: 52.569,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})));

function SvgRalaliConnectIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

export default SvgRalaliConnectIllustration;